import axios from 'axios';
import { UiContainer } from '../../state/ui';
import { useHistory } from 'react-router-dom';
import { useTranslation } from '../../i18n/i18n';
import { useEffect } from 'react';

export function NetworkErrorHandling() {
	const ui = UiContainer.useContainer();
	const history = useHistory();
	const urls = useTranslation().routes;

	useEffect(() => {
		const interceptor = axios.interceptors.response.use(
			(res) => res,
			(error) => {
				if (error.response) {
					switch (error.response.status) {
						case 401:
							const { method, url, withCredentials, data } = error.response.config;
							const request = { method, url, withCredentials, data };
							const { pathname: previousLocation } = history.location;
							history.push({
								pathname: urls.login,
								state: { request, previousLocation },
							});
							ui.showLoginModal(true);
							break;
					}
					return Promise.reject(error);
				}

				/*
				 * No response at all: offline, dns, timeout, a cancelled request. This used to return
				 * the error, which resolves it - so `await axios(...)` handed back an Error object,
				 * `catch` never ran, and every write in the app carried on as though it had gone
				 * through. A subscription schedule was deleted from the page while the server still
				 * had it and went on creating orders.
				 */
				return Promise.reject(error);
			}
		);

		return () => {
			axios.interceptors.response.eject(interceptor);
		};
	}, [ui, history, urls]);

	return null;
}
